export const GET_ALL_LOOKUPS_SUCCESS =
  'CBRE-PJM-ADMIN-ROOT-DETAILS/GET_ALL_LOOKUPS_SUCCESS';
export const GET_ALL_LOOKUPS_FAILURE =
  'CBRE-PJM-ADMIN-ROOT-DETAILS/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-pjm-admin-root-details';
